<template>
  <div class="product">
    <!-- nav -->
    <Navbar style="height: 7.3rem" id="top" />
    <!-- banner -->
    <section class="banner">
      <img src="@/assets/images/productbanner.png" alt="" />
    </section>
    <div class="content">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/product' }"
          >产品系列</el-breadcrumb-item
        >
        <el-breadcrumb-item>产品详情</el-breadcrumb-item>
      </el-breadcrumb>
      <el-divider></el-divider>
      <!-- <img src="@/assets/images/productDetail1.png" alt="" /> -->
      <div v-for="(item, index) in detail_images" :key="index">
        <img :src="item" alt="" />
      </div>
    </div>
    <!-- foot -->
    <Foot />
  </div>
</template>

<script>
import { Loading } from "element-ui";
import Navbar from "@/components/nav.vue";
import Foot from "@/components/foot.vue";
import { getListDataDetail } from "@/request/http";
export default {
  name: "productDetail",
  components: {
    Navbar,
    Foot,
  },
  data() {
    return {
      detail_images: [],
      loading: true,
    };
  },
  created() {
    this.getDetail();
  },
  watch: {
    $route() {
      this.scroll();
    },
  },
  mounted() {
    this.scroll();
  },
  methods: {
    getDetail() {
      let loadingInstance1 = Loading.service({ fullscreen: true });
      let id = this.$route.query.id;
      getListDataDetail(id).then((res) => {
        this.detail_images = res.data.detail_images;
        this.$nextTick(() => {
          // 以服务的方式调用的 Loading 需要异步关闭
          loadingInstance1.close();
        });
      });
    },
    scroll() {
      document.getElementById("top").scrollIntoView({ behavior: "smooth" });
    },
  },
};
</script>

<style lang="scss" scoped>
.banner {
  width: 100%;
  img {
    width: 100%;
  }
}
.content {
  width: 80%;
  margin: 2rem auto;
  img {
    width: 100%;
  }
}
.el-breadcrumb {
  font-size: 1.2rem;
}
</style>
